/* Carousel controls under page-width carousels (Titanium Wares, 15/09/2026): "‹ 1 / 2 ›" so people see there is
   more to slide. Uses the theme's slideshow component (previous()/next(), visibleSlides, slideshow:select). The
   theme's overlay arrows are hidden by CSS in snippets/st-contain.liquid.
   29/09/2026 speed: set up only when a carousel comes near the screen (not all at load), read the column count
   BEFORE inserting the bar and cache it per breakpoint - reading computed styles right after inserting forced a
   full-page style recalc on every carousel (0.4–0.6 s on a phone in the audit). */
const SEL = '.section-carousel slideshow-component';
const ARROW = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 4l6 6-6 6"/></svg>';
const MOBILE = window.matchMedia('(max-width: 749px)');

function init(c) {
  if (c.dataset.stCounter) return;
  const container = c.querySelector('slideshow-container');
  if (!container) return;
  c.dataset.stCounter = '1';
  // columns from the section's CSS variables, read once per breakpoint (the theme's visibleSlides is only measured
  // once the carousel scrolls into view)
  const colsCache = {};
  const cols = () => {
    const key = MOBILE.matches ? 'm' : 'd';
    if (!colsCache[key]) {
      const v = parseInt(getComputedStyle(c).getPropertyValue(MOBILE.matches ? '--carousel-mobile-columns' : '--carousel-columns'), 10);
      colsCache[key] = Math.max(1, v || c.visibleSlides?.length || 1);
    }
    return colsCache[key];
  };
  cols(); // read before the bar goes in: no forced recalc of a freshly changed page
  const total = () => c.slides?.length || c.querySelectorAll('slideshow-slides > *').length;

  const bar = document.createElement('div');
  bar.className = 'st-cc';
  bar.innerHTML = `<button type="button" class="st-cc__btn st-cc__btn--prev" aria-label="Previous">${ARROW}</button><span class="st-cc__count" aria-live="polite"></span><button type="button" class="st-cc__btn st-cc__btn--next" aria-label="Next">${ARROW}</button>`;
  const prev = bar.querySelector('.st-cc__btn--prev'), next = bar.querySelector('.st-cc__btn--next'), count = bar.querySelector('.st-cc__count');
  const update = () => {
    const vis = cols();
    const pages = Math.max(1, Math.ceil(total() / vis));
    const page = Math.min(pages, Math.floor((c.current || 0) / vis) + 1);
    count.textContent = `${page} / ${pages}`;
    bar.hidden = pages <= 1;
    prev.disabled = page <= 1;
    next.disabled = page >= pages;
  };
  update(); // fill the bar before it is attached
  container.insertAdjacentElement('afterend', bar);
  // page by the column count (the theme's next()/previous() step by its measured visible slides, which is empty until
  // the carousel has been in the viewport, so it would move one card at a time)
  prev.addEventListener('click', () => c.select(Math.max(0, (c.current || 0) - cols())));
  next.addEventListener('click', () => c.select(Math.min(total() - 1, (c.current || 0) + cols())));
  c.addEventListener('slideshow:select', update);
  MOBILE.addEventListener?.('change', update);
}

const io = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        io.unobserve(e.target);
        init(e.target);
      }
    }, { rootMargin: '600px 0px' })
  : null;
const boot = () => document.querySelectorAll(SEL).forEach((c) => (io ? io.observe(c) : init(c)));
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
